import { createActionGroup, props, union } from '@ngrx/store';

import { FinnairBoundItem } from '@fcom/dapi/api/models/finnair-bound-item';
import { FinnairAirCalendarChangeListResponse } from '@fcom/dapi/api/models';

export const ChangeActions = createActionGroup({
  source: 'ChangeActions',
  events: {
    'Toggle Outbound': props<{ bound: FinnairBoundItem }>(),
    'Toggle Inbound': props<{ bound: FinnairBoundItem }>(),
    'Set Outbound': props<{ bound: FinnairBoundItem }>(),
    'Set Inbound': props<{ bound: FinnairBoundItem }>(),
    'Set Dates': props<{ dates: string[] }>(),
    'Set Change List': props<{ list: FinnairAirCalendarChangeListResponse }>(),
  },
});

const _group = union(Object.keys(ChangeActions).reduce((actions, key) => (actions[key] = ChangeActions[key]), {}));

export type SelectActionsUnion = typeof _group;
